import get from 'lodash.get'
import moment from 'moment'

export function sanitizeTicketItem(item, locationId) {
  const addOns = item.addon ? item.addon.price : 0

  item = {
    item_id: item.id,
    addon_id: get(item, 'addon.id', null),
    coupon_id: get(item, 'coupon.id', null),
    color: item.color,
    price: item.price,
    pattern: item.pattern,
    qty: item.qty,
    discount_price: item.discount,
    tax:
      get(item, `prices.${locationId}.tax`, get(item, 'prices.global.tax', 0))
      * item.qty,
  }

  item.addon_price = addOns
  item.subtotal = (item.price * item.qty) + addOns
  item.total = (item.subtotal - item.discount_price) + item.tax
  return item
}

export function sanitizeTicket(ticket, location) {
  const item = { ...ticket }

  item.items = item.items.map(item => sanitizeTicketItem(item, location))

  item._ref = item.id
  item.customer_id = item.customer.id
  item.service_id = item.service.id
  item.total_pieces = item.totalPieces

  if (item.due_date) {
    item.due_date = moment(item.due_date).format('YYYY-MM-DD HH:mm:ss')
  }
  item.subtotal = ticket.subTotal
  item.discount = ticket.coupons
  item.tax_scope = location.tax_scope ?? 'full_price'

  delete item.totalPieces
  delete item.subTotal
  delete item.customer
  delete item.service
  delete item.coupons
  delete item.id

  return item
}
